import { useEffect, useState } from "react";
import { Mail, UserRound } from "lucide-react";
import { toast } from "sonner";

import api from "../../lib/api";
import { Loading } from "../../components/shared";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";

export default function ResidentProfile() {
  const [profile, setProfile] = useState(null);
  const [editing, setEditing] = useState(false);

  useEffect(() => {
    api.get("/resident/me").then((response) => setProfile(response.data.profile));
  }, []);

  if (!profile) return <Loading />;

  const save = async () => {
    try {
      const response = await api.patch("/resident/me", {
        alternate_mobile: profile.alternate_mobile,
        communication_address: profile.communication_address,
        emergency_contact_name: profile.emergency_contact_name,
        emergency_contact_number: profile.emergency_contact_number,
        preferred_communication: profile.preferred_communication,
      });
      setProfile(response.data.profile);
      setEditing(false);
      toast.success("Profile details updated");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Could not update profile details");
    }
  };

  return (
    <div data-testid="resident-profile-page">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">My Profile</p>
      <h1 className="mt-2 font-display text-4xl font-bold text-slate-900">Your account</h1>
      <section className="mt-8 max-w-xl border border-slate-200 bg-white p-6">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center bg-blue-50 text-primary">
            <UserRound className="h-5 w-5" />
          </div>
          <div>
            <p className="font-display text-xl font-semibold text-slate-900" data-testid="resident-profile-name">
              {profile.name}
            </p>
            <p className="text-sm text-slate-600">Resident account</p>
          </div>
        </div>
        <div className="mt-7 border-t border-slate-200 pt-5">
          <p className="flex items-center gap-2 text-sm text-slate-700" data-testid="resident-profile-email">
            <Mail className="h-4 w-4 text-slate-500" />
            {profile.email}
          </p>
          <p className="mt-4 text-sm text-slate-600">
            Communication preference: {profile.preferred_communication}
          </p>
          {editing ? (
            <div className="mt-5 grid gap-3" data-testid="resident-profile-edit-form">
              <Input data-testid="resident-profile-alternate-mobile" onChange={(event) => setProfile({ ...profile, alternate_mobile: event.target.value })} placeholder="Alternate mobile" value={profile.alternate_mobile || ""} />
              <Input data-testid="resident-profile-address" onChange={(event) => setProfile({ ...profile, communication_address: event.target.value })} placeholder="Correspondence address" value={profile.communication_address || ""} />
              <Input data-testid="resident-profile-emergency-name" onChange={(event) => setProfile({ ...profile, emergency_contact_name: event.target.value })} placeholder="Emergency contact name" value={profile.emergency_contact_name || ""} />
              <Input data-testid="resident-profile-emergency-number" onChange={(event) => setProfile({ ...profile, emergency_contact_number: event.target.value })} placeholder="Emergency contact number" value={profile.emergency_contact_number || ""} />
              <Button data-testid="resident-profile-save" onClick={save}>Save safe details</Button>
            </div>
          ) : <Button className="mt-5" data-testid="resident-profile-edit" onClick={() => setEditing(true)} variant="outline">Edit safe details</Button>}
        </div>
      </section>
    </div>
  );
}